import { useEffect } from 'react';
import { setExtra, setUser } from '@sentry/remix';
import { useConvex, useQuery } from 'convex/react';
import { useConvexSessionIdOrNullOrLoading, getConvexAuthToken } from '~/lib/stores/sessionId';
import { useChatId } from '~/lib/stores/chatId';
import { setProfile } from '~/lib/stores/profile';
import { getConvexProfile } from '~/lib/convexProfile';
import { api } from '@convex/_generated/api';

export function UserProvider({ children }: { children: React.ReactNode }) {
  const convexMemberId = useQuery(api.sessions.convexMemberId);
  const sessionId = useConvexSessionIdOrNullOrLoading();
  const chatId = useChatId();
  const convex = useConvex();

  useEffect(() => {
    if (sessionId) {
      setExtra('sessionId', sessionId);
    }
  }, [sessionId]);

  useEffect(() => {
    setExtra('chatId', chatId);
  }, [chatId]);

  const tokenValue = (convex as any)?.sync?.state?.auth?.value;

  useEffect(() => {
    async function updateProfile() {
      if (convexMemberId) {
        setUser({
          id: convexMemberId ?? '',
          username: '',
          email: undefined,
        });

        try {
          const token = getConvexAuthToken(convex);
          if (token) {
            void convex.action(api.sessions.updateCachedProfile, { convexAuthToken: token });
            const convexProfile = await getConvexProfile(token);
            setProfile({
              username: convexProfile.name ?? '',
              email: convexProfile.email || '',
              avatar: '',
              id: convexProfile.id || convexMemberId || '',
            });
          }
        } catch (error) {
          console.error('Failed to fetch Convex profile:', error);
          setProfile({
            username: '',
            email: '',
            avatar: '',
            id: convexMemberId ?? '',
          });
        }
      }
    }
    void updateProfile();
  }, [convex, tokenValue, convexMemberId]);

  return children;
}
